'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_sjsr_package$() {
}
export { $c_sjsr_package$ as $c_sjsr_package$ };
$p = $c_sjsr_package$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_sjsr_package$;
/** @constructor */
function $h_sjsr_package$() {
}
export { $h_sjsr_package$ as $h_sjsr_package$ };
$h_sjsr_package$.prototype = $p;
$p.df = (function(array) {
  var len = array.a.length;
  var result = [];
  var i = 0;
  while ((i !== len)) {
    var x1 = i;
    result.push(array.a[x1]);
    i = ((1 + i) | 0);
  }
  return result;
});
var $d_sjsr_package$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_sjsr_package$, "scala.scalajs.runtime.package$", ({
  wa: 1
}));
export { $d_sjsr_package$ as $d_sjsr_package$ };
var $n_sjsr_package$;
function $m_sjsr_package$() {
  if ((!$n_sjsr_package$)) {
    $n_sjsr_package$ = new $c_sjsr_package$();
  }
  return $n_sjsr_package$;
}
export { $m_sjsr_package$ as $m_sjsr_package$ };
